import {
  CustomTable,
  CustomeDialog,
  DeleteModal,
} from "../../../shared";
import * as React from "react";
import { Button, Radio, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useParams } from "react-router-dom";
import { sortItems } from "../../../utils";
import { AddOrEditAddress } from "./AddOrEditAddress";
import { useClientAccountAddress } from "../hooks";
export const AddressesList = () => {
  const { id } = useParams()

  const {
    state,
    isDeletable,
    isCreateble,
    isEditable,
    globalData,
    handleInputChange,
    handleModal,
    onDeleteAddress,
    onCreateAddress,
    onUpdateAddress,
    onChangeDefault,
  } = useClientAccountAddress({ id: id })

  const {
    isLoading,
    dataList,
    isOpenDelete,
    isModalType,
    isOpenModal,
  } = state

  const ActionButtons = ({ id, row }) => {
    return (
      <div className="action-buttons">
        {isEditable && (<img
          alt="edit"
          src="/icons/ic_edit.svg"
          onClick={() => handleModal('edit', true, row)}
        />
        )}
        {isDeletable && (<img
          alt="delete"
          src="/icons/ic_delete.svg"
          className={` ${row.is_it_default &&
            "disabled-img"
            }`}
          onClick={() => !row.is_it_default && handleModal('delete', true, id)}
        />
        )}
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Address",
        accessor: "address",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Email",
        accessor: "email",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Phone Number",
        accessor: "phone_formatted",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Set as default",
        accessor: "is_it_default",
        Cell: ({ value, row }) => {
          console.log('dddis_it_default', value);

          return (
            <Stack alignItems="center">
              <Radio
                checked={value ? true : false}
                onClick={() => !value && onChangeDefault(row.original.id)}
                name="radio-buttons"
                sx={{
                  p: "3.5px",
                }}
              />
            </Stack>
          )
        },
        disableSortBy: true,
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        accessor: (row, index) => {
          return (
            <ActionButtons
              id={row.id}
              row={row}
            />
          );
        },
      },
    ],
    []
  );




  return (
    <>

      <CustomTable
        columns={columns}
        data={dataList}
        searchBar={false}
        tableTitle="Addresses"
        pagination={false}
        isLoading={isLoading}
        headerRightContent={
          <Stack direction="row" gap="16px">
            {isCreateble && (
              <Button
                type="button"
                size="medium"
                variant="text"
                startIcon={<AddIcon />}
                onClick={() => handleModal("add", true)}
              >
                Add
              </Button>
            )}
          </Stack>
        }
      />
      <CustomeDialog
        open={isOpenModal}
        PaperProps={{
          sx: { width: "582px", height: "410", p: "16px" },
        }}
        title={`${isModalType === "add" ? "Add" : "Edit"} Address`}
        content={
          <AddOrEditAddress
            state={state}
            onChange={handleInputChange}
            onCreateAddress={onCreateAddress}
            handleClose={() => handleModal("add", false)}
            onUpdateAddress={onUpdateAddress}
            globalData={globalData}
          />
        }
      />
      <DeleteModal
        open={isOpenDelete}
        handleClose={() => handleModal("delete", false, null)}
        onConfirm={onDeleteAddress}
      />
    </>
  );
};
